#Notifications {
  display: flex;
  position: relative;
}

#Notifications ul {
  display: none;
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  background-color: white;
  z-index: 500;
  color: black;
  border: 1px solid #dce1e5;
  border-radius: 3px;
  box-shadow: 0 1px 6px 0 rgba(210, 214, 220, 0.3);
  overflow: hidden;
  width: 320px;
  max-height: 300px;
  overflow-y: scroll;
}
#Notifications ul[data-is-opened="true"] {
  display: flex;
}

#Notifications ul li {
  list-style-type: none;
}
#Notifications ul li:not(:last-of-type) {
  border-bottom: 1px solid #f3f6f9;
}
#Notifications ul li[data-status="aborted"],
#Notifications ul li[data-status="failed"] {
  color: #a94442;
}

#Notifications ul li.action svg {
  color: #697177;
  margin-right: 6px;
}

#Notifications ul li .progress {
  width: 100%;
  border-radius: 25px;
  box-shadow: none;
  position: relative;
  overflow: hidden;
  margin: 8px 0;
}
#Notifications ul li .progress .foreground {
  position: absolute;
  top: 0;
  transition: left 0.3s ease;
  height: 100%;
  width: 100%;
  border-radius: 25px;
}
